/*
Author: Vaishnavi
Date: 21/11/2019
Issue Description: Upload logo/image file as per design guidelines
*/

/*
Author: Vinod
Date: 23/03/2020
Issue Description: While Uploading Template Getting Error "File uploading failed File size too big".
search_string: PL_2970
*/
<template>
  <!-- Usage
  <upload-file name="annex" tobucket="false" @change="onFileChange($event,'annexure')" :status="statusAnnex"></upload-file>-->
  <!-- if there is no logo -->
  <div>
    <!-- if there is no logo -->
    <div
      class="upload-file"
      v-show="status && !logo"
      @dragover.prevent
      @drop="upload_file"
      @dragover="dragging"
      :class="{'dragg': dragg}"
    >
      <div class="uploadBlock">
        <div class="alignCenter">
          <div>
            <img src="@/assets/uploadFile.svg" />
          </div>

          <span class="uploadText">
            Drop your File here, or
            <span class="upload-button-file">
              <label for="upload">Browse</label>
              <input
                type="file"
                name="photo"
                class="upload-photo-file"
                id="upload"
                ref="file_upload"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                @change="uploadFile($event.target.files[0])"
              />
            </span>
          </span>
          <span class="upload-btn-below-text">CSV, XLS or XLSX. Max size 5MB</span>
        </div>
      </div>
    </div>

    <div class="progressbar-wrapper" v-show="uploading">
      <div class="content_div">
        <p class="file-name">Uploading "{{fileName}}"</p>
        <p
          class="percentage margin-tb-s"
          v-if="Number(minutes_remaining)"
        ><b>{{progressPercentage}}%</b> - {{minutes_remaining}}:{{seconds_remaining}} min remaining</p>
        <p v-if="sheetLoading" style="font-weight: bold;">Uploading...</p>
        <p
          class="percentage margin-tb-s"
          v-if="!Number(minutes_remaining) && Number(seconds_remaining)"
        ><b>{{progressPercentage}}%</b> - {{seconds_remaining}} sec remaining</p>
        <!-- <p v-if="!Number(minutes_remaining) && !Number(seconds_remaining) && progressPercentage == 100"><b>{{progressPercentage}}% complete</b></p> -->
        <p v-if="!sheetLoading">Uploaded</p>
      </div>
      <a href="javascript:void(0)" @click="cancelUploading">
        <img src="@/assets/closeFile.svg" alt="close" />
      </a>
      <div class="progressbar" id="progress"></div>
    </div>
    <!-- <div class="uploading-file" v-if="uploading">
      <div class="uploading-container">
        <div class="upload-info">
          <div class="uploading-btn-text">Uploading</div>
          <div class="uploading-btn-text">{{ file.name }}</div>
          <div class="progress-bar">
            <div class="progress complete"></div>
          </div>
          <div class="uploading-btn-text size">{{ parseInt(file.size / 1024) }}kb</div>
        </div>
        <button class="btn-secondary" @click="status=true
        uploading=false">Cancel</button>
      </div>
    </div>-->
    <div class="upload-failed" v-if="failed">
      <div class="uploadingstatus">
        <div class="upload-btn-text">File uploading failed</div>
        <div class="upload-btn-below-text">{{ uploadStatusMessage }}</div>
      </div>
      <img src="@/assets/retryFile.svg" class="retry" @click="retry" />
      <img src="@/assets/deleteIcon.svg" class="delete" @click="refresh" />
    </div>
    <div class="uploaded" v-if="uploaded">
      <div class="uploadedstatus">
        <div class="upload-btn-text">Uploaded Successfully</div>
        <div class="upload-btn-below-text">{{ fileName }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  get_axios_file_instance,
  api_variables,
  errorHandler,
  cancelSource
} from "@/apis/variables.js";
import { mapGetters, mapActions, mapState } from "vuex";
// var axios_instance = get_axios_file_instance(api_variables.SERVICE_UPLOAD_LOGO);
export default {
  props: {
    maxSize: {
      type: Number,
      default: 5242880
    },
    name: {
      type: String,
      default: "upload"
    },
    tobucket: {
      type: Boolean,
      default: true
    },
    logo: {
      type: String
    },
    apiUrl: {
      type: String
    },
    loggedInUser: {
     type:String 
    },
    requestObject: {
      type: {}
    },
    params: {
      type: Object,
      default: null
    },
    sheetLoading: {
      type: Boolean,
      default: true,
    }
    // status:{
    //   type: Number,
    //    default: 0
    // }
  },
  data() {
    return {
      // status 0 for notUploaded
      // status 1 for uploading
      // status 2 for uploaded
      file: null,
      uploadStatusMessage: "",
      fileNameDetails: "",
      status: true,
      progressPercentage: null,
      seconds_remaining: null,
      minutes_remaining: null,
      fileName: "",
      uploading: false,
      uploaded: false,
      failed: false,
      uploadedUrl: "",
      dragg: false,
      fileData: null,
      pdfPattern: "([a-zA-Z0-9s_\\.-:])+(.pdf)$",
      xlsPattern: "([a-zA-Z0-9s_\\.-:])+(.xls|.xlsx)$",
      imgPattern: "([a-zA-Z0-9s_\\.-:])+(.png|.jpg|.jpeg)$",
      cancelRequest: null
    };
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    }
  },
  activated() {
    this.uploading = false;
    this.uploaded = false;
    this.failed = false;
    this.status = true;
  },
  methods: {
    fileType() {
      if (this.file.type == "xls") {
        return require("@/assets/excel.svg");
      } else {
        if (this.file.type == "pdf") {
          return require("@/assets/pdf.svg");
        } else {
          return require("@/assets/image.svg");
        }
      }
    },

    retry(event) {
      this.failed = false;
      this.status = true;
      this.uploading = false;
      this.uploadFile(this.fileData);
    },
    upload_file(e) {
      e.stopPropagation();
      e.preventDefault();
      this.uploadFile(e.dataTransfer.files[0]);
    },
    dragging(e) {
      this.dragg = true;
    },
    async uploadFile(uploadFile) {
      console.log('entry');
      console.log(this.params, 'params');
      try {
        let upload_axios_instance = get_axios_file_instance(this.apiUrl);
        this.dragg = false;
        if (uploadFile && uploadFile.name) {
          this.fileName = uploadFile.name;
          if (
            uploadFile.type ==
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
            uploadFile.type == "application/vnd.ms-excel" ||
            uploadFile.type == "text/csv"
          ) {
            this.uploading = true;
            this.$root._data.isSaving = true
            this.uploaded = false;
            this.status = false;
            this.file = uploadFile;
            this.failed = false;
            console.log(this.loggedInUser, 'loggedIn');
            let formData = new FormData();
            formData.append("file", uploadFile);
            formData.append("le_id", this.le_id);
          
            if (this.params) {
              Object.keys(this.params).forEach(key => formData.append(key, this.params[key]));
            }
            let started_at = new Date();
            const config = {
              cancelToken: new cancelSource(c => {
                this.cancelRequest = c;
              }),
              onUploadProgress: progressEvent => {
                // Do whatever you want with the native progress event
                this.progressPercentage = Math.round(
                  (progressEvent.loaded * 100.0) / progressEvent.total
                );
                let seconds_elapsed =
                  (new Date().getTime() - started_at.getTime()) / 1000;
                let bytes_per_second = seconds_elapsed
                  ? progressEvent.loaded / seconds_elapsed
                  : 0;
                let Kbytes_per_second = bytes_per_second / 1000;
                let remaining_bytes =
                  progressEvent.total - progressEvent.loaded;
                this.minutes_remaining = Math.floor(
                  remaining_bytes / bytes_per_second / 60
                ) < 10 ? '0' + Math.floor(
                  remaining_bytes / bytes_per_second / 60
                ) : Math.floor(
                  remaining_bytes / bytes_per_second / 60
                );
                this.seconds_remaining =
                  Math.floor((remaining_bytes / bytes_per_second) % 60) < 10
                    ? "0" +
                      Math.floor((remaining_bytes / bytes_per_second) % 60)
                    : Math.floor((remaining_bytes / bytes_per_second) % 60);
                document.getElementById("progress").style.width =
                  this.progressPercentage + "%";
                if (this.progressPercentage != 100) {
                  document.getElementById(
                    "progress"
                  ).style.borderTopRightRadius = 0 + "px";
                  document.getElementById(
                    "progress"
                  ).style.borderBottomRightRadius = 0 + "px";
                } else {
                  document.getElementById(
                    "progress"
                  ).style.borderTopRightRadius = 12 + "px";
                  document.getElementById(
                    "progress"
                  ).style.borderBottomRightRadius = 12 + "px";
                }
              }
            };
            let res = await upload_axios_instance.post("", formData, config);
            if (res.data.status) {
              this.$root._data.isSaving = false;
              this.uploading = false;
              this.uploaded = true;
            }
            this.$emit("uploadTemplate", res);
            this.$refs.file_upload.value = null;
          } else {
            this.uploading = false;
            this.failed = true;
            this.status = false;
            this.fileData = uploadFile;
            this.uploadStatusMessage = "Invalid file type";
          }
        }
      } catch (error) {
        this.$refs.file_upload.value = null;
        this.uploading = false;
        this.$root._data.isSaving = false;
        this.failed = true;
        this.status = false;
        this.$emit("uploadTemplate", error);
      }
    },
    cancelUploading() {
      this.cancelRequest("The request is cancelled by user");
    },
    uploadingFunc() {
      try {
        var i = 0;
        if (i == 0) {
          i = 1;
          var elem = document.getElementById("animated");
          var width = 1;
          var id = setInterval(frame, 10);
          function frame() {
            if (width >= 100) {
              clearInterval(id);
              i = 0;
            } else {
              width += 10;
              elem.style.width = width + "px";
            }
          }
        }
      } catch (error) {
        throw errorHandler(error.response);
      }
    },
    getFileType(filename) {
      if (new RegExp(this.imgPattern).test(filename)) {
        return "@/assets/image.svg";
      } else if (new RegExp(this.xlsPattern).test(filename)) {
        return "@/assets/excel.svg";
      } else if (new RegExp(this.pdfPattern).test(filename)) {
        return "@/assets/pdf.svg";
      } else {
        return "";
      }
    },
    refresh() {
      this.uploading = false;
      this.uploaded = false;
      this.failed = false;
      this.status = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
.dragg {
  background-color: #34c0be;
  opacity: 0.4;
}
.upload-file {
  width: 316px;
  height: 146px;
  border-radius: 12px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
  padding: 12px 12px 12px 12px;

  .uploadBlock {
    width: 292px;
    height: 122px;
    border-radius: 6px;
    border: 1px dashed #d2d2d2;

    .alignCenter {
      display: grid;
      margin-top: 20px;
      justify-content: center;
      :first-child {
        display: flex;
        justify-content: center;
        margin-bottom: 8px;
      }
      .upload-button-file {
        display: flex;
        justify-content: center;
        cursor: pointer;
        label {
          cursor: pointer;
          width: 47px;
          height: 15px;
          font-size: 12px;
          margin-top: -15px;
          margin-left: 145px;
          font-weight: 600;
          color: #37c6c0;
        }
        .upload-photo-file {
          opacity: 0;
          position: absolute;
          z-index: -1;
        }
      }

      .uploadText {
        width: 100%;
        height: 15px;
        font-family: Montserrat;
        font-size: 12px;
        font-weight: 600;
        margin-bottom: 4px;
        color: #646464;
      }
      .upload-btn-below-text {
        font-family: Montserrat;
        font-size: 10px;
        text-align: center;
        color: #6d7278;
      }
    }
  }
}

.delete-img {
  margin-left: auto;
  :first-child {
    img {
      margin-right: 16px;
    }
  }
}
.uploaded {
  width: 316px;
  height: 146px;
  border-radius: 12px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.08);
  background-color: #f6ffff;
  .uploadedstatus {
    width: 182px;
    height: 146px;
    border-radius: 12px;
    background-color: #f6ffff;
  }
  .upload-btn-text {
    width: 316px;
    height: 15px;
    font-size: 12px;
    padding: 60px 0 12px 32px;
    font-weight: 600;
    color: #646464;
  }
  .upload-btn-below-text {
    width: 316px;
    height: 18px;
    font-size: 10px;
    padding: 8px 0 0 32px;
    color: #6d7278;
  }
}

.uploading-file {
  width: 316px;
  height: 146px;
  border-radius: 12px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
  .uploadingstatus {
    width: 182px;
    height: 146px;
    border-radius: 12px;
    background-color: #f6ffff;
  }
  img {
    float: right;
    margin-right: 32px;
    margin-top: 66px;
    cursor: pointer;
  }
  .upload-btn-text {
    width: 316px;
    height: 15px;
    font-size: 12px;
    padding: 60px 0 12px 32px;
    font-weight: 600;
    color: #646464;
  }
  .upload-btn-below-text {
    width: 316px;
    height: 18px;
    font-size: 10px;
    padding: 8px 0 0 32px;
    color: #6d7278;
  }
}
.upload-failed {
  width: 316px;
  height: 146px;
  border-radius: 12px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.08);
  background-color: #fff6f6;
  padding: 60px 0 0 32px;
  .retry {
    float: right;
    margin-right: 62px;
    margin-top: -28px;
    cursor: pointer;
  }
  .delete {
    float: right;
    margin-right: 32px;
    margin-top: -28px;
    cursor: pointer;
  }
  .upload-btn-text {
    width: 316px;
    height: 15px;
    font-size: 12px;
    font-weight: 600;
    color: #646464;
  }
  .upload-btn-below-text {
    width: 316px;
    height: 18px;
    font-size: 10px;
    color: #6d7278;
  }
}

.uploading-btn-text {
  color: #6c6c6c;
  font-size: $font-size-small;
  margin-top: 2px;
  &.size {
    float: right;
  }
}
.btn-secondary {
  background-color: white;
  color: $color-secondary;
  border-radius: 4px;
  border: 1px solid $color-secondary;
  height: 30px;
  padding: 0px 20px;
  font-size: $font-size-small;
  width: auto;
  margin-top: auto;
  margin-bottom: 10px;
}

.file-name {
  width: 100%;
  word-break: break-all;
}
.upload-file-text {
  color: #6c6c6c;
  font-size: $font-size-small;
  margin-top: 10px;
  text-decoration: underline;
}

.upload-info {
  margin-top: auto;
  padding-left: 20px;
  padding-top: 15px;
}

.upload-btn-below-text {
  font-size: 10px;
  color: #6e6e6e;
}
.image {
  background: url("../assets/image.svg") no-repeat fixed;
  background-size: 36px 36px;
}

.excel {
  background: url("../assets/excel.svg") no-repeat fixed;
  background-size: 36px 36px;
}

.pdf {
  background: url("../assets/pdf.svg") no-repeat fixed;
  background-size: 36px 36px;
}
.errorimage {
  width: 10%;
}
.file-uploading {
  width: 316px;
  border: 1px solid #e6e6e6;
  height: 100%;
  border-radius: 12px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
  padding: 12px 12px 12px 12px;
}

.progressbar-wrapper {
  position: relative;
  z-index: 1;
  width: 316px;
  min-height: 150px;
  height: 100%;
  border-radius: 12px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
  padding: 12px 12px 12px 12px;
  a {
    position: absolute;
    right: 26px;
    top: 63px;
  }
}

.progressbar {
  position: absolute;
  top: -1px;
  bottom: 0;
  left: 0;
  min-height: 150px;
  width: 0%;
  border-radius: 12px;
  background-color: #f6ffff;
  z-index: -1;
}
.content_div {
  position: absolute;
  top: 30%;
  left: 30px;
  width: 70%;
}
</style>
